import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HeadquarterComponent } from './headquarter.component';
import { ProcurementComponent } from './pages/procurement/procurement.component';
import { PressReleasesComponent } from './../headquarter/pages/press-releases/press-releases.component';
import { RecruitmentComponent } from './pages/recruitment/recruitment.component';
import { RecruitmentDetailsComponent } from './pages/recruitment-details/recruitment-details.component';
import { CircularComponent } from './pages/circular/circular.component';
import { AwardsComponent } from './pages/awards/awards.component';
import { SitemapComponent } from './pages/sitemap/sitemap.component';
import { SeeyourdepotComponent } from './pages/seeyourdepot/seeyourdepot.component';
import { ContactusComponent } from './pages/contactus/contactus.component';
import { AnnualReportComponent } from './pages/annual-report/annual-report.component';
import { PressReleaseDetailsComponent } from './pages/press-release-details/press-release-details.component';
import { CircularDetailsComponent } from './pages/circular-details/circular-details.component';
import { DirectoryComponent } from './pages/directory/directory.component';
import { NewsListComponent } from './pages/news-list/news-list.component';
import { BoardDirectorsComponent } from './pages/board-directors/board-directors.component';
import { AwardDetailsComponent } from './pages/award-details/award-details.component';
import { NewsComponent } from './pages/news/news.component';
import { HandbookComponent } from './pages/handbook/handbook.component';
import { WhatsNewDetailsComponent } from './pages/whats-new-details/whats-new-details.component';
import { FeedbackFormComponent } from './pages/feedback-form/feedback-form.component';
import { GalleryCategoryComponent } from './pages/gallery-category/gallery-category.component';
import { MousListComponent } from './pages/mous-list/mous-list.component';
import { NoticeOfBoardMeetingComponent } from './pages/notice-of-board-meeting/notice-of-board-meeting.component';
import { IndependentNonOfficialDirectorsComponent } from './pages/independent-non-official-directors/independent-non-official-directors.component';
import { ContentSearchComponent } from './pages/content-search/content-search.component';
import { SampleContentPageComponent } from './pages/sample-content-page/sample-content-page.component';
import { VigilanceContactDirectoryComponent } from './pages/vigilance-contact-directory/vigilance-contact-directory.component';
import { PurchaseContactDirectoryComponent } from './pages/purchase-contact-directory/purchase-contact-directory.component';
import { OfficeOrderComponent } from './pages/office-order/office-order.component';
import { EmployeeCornerComponent } from './pages/employee-corner/employee-corner.component';
import { EmployeeCornerDetailsComponent } from './pages/employee-corner-details/employee-corner-details.component';
import { OrganisationStructureComponent } from './pages/organisation-structure/organisation-structure.component';
import { GalleryComponent } from './pages/gallery/gallery.component';
import { VideoGalleryComponent } from './pages/video-gallery/video-gallery.component';
import { VideoCategoryComponent } from './pages/video-category/video-category.component';
import { HospitalListFciHqrsComponent } from './pages/hospital-list-fci-hqrs/hospital-list-fci-hqrs.component';
import { MisKpiZonesComponent } from './pages/mis-kpi-zones/mis-kpi-zones.component';
import { MisKpiRegionsComponent } from './pages/mis-kpi-regions/mis-kpi-regions.component';
import { BlogsComponent } from './pages/blogs/blogs.component';
import { BlogdetailsComponent } from './pages/blogdetails/blogdetails.component';
 import { FeedbackComponent } from './pages/feedback/feedback.component';
import { ScreenReaderComponent } from './pages/screen-reader/screen-reader.component';
import { ImmovablePropertyComponent } from './pages/immovable-property/immovable-property.component';
import { ContactDirectoryComponent } from './pages/contact-directory/contact-directory.component';
import  {NewslistArchiveComponent} from './pages/newslist-archive/newslist-archive.component';
import  {PressreleaseArchiveComponent}  from './pages/pressrelease-archive/pressrelease-archive.component';
import  {CircularArchiveComponent}  from './pages/circular-archive/circular-archive.component';
import  {AwardArchiveComponent}  from './pages/award-archive/award-archive.component';
import  {TenderArchiveComponent}  from './pages/tender-archive/tender-archive.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { TendersComponent } from './pages/tenders/tenders.component';
import { TendersDetailsComponent } from './pages/tenders-details/tenders-details.component';
import { DepotDetailsComponent } from './pages/depot-details/depot-details.component';
import { WebsiteInnerLayoutComponent } from './pages/website-inner-layout/website-inner-layout.component';
import { GalleryArchiveComponent } from './pages/gallery-archive/gallery-archive.component';
import { VideoGalleryArchiveComponent } from './pages/video-gallery-archive/video-gallery-archive.component';
import {GalleryCategoryArchiveComponent}   from './pages/gallery-category-archive/gallery-category-archive.component';
import {VideoCategoryArchiveComponent}   from './pages/video-category-archive/video-category-archive.component';
import { FarmersBanefitedComponent } from './statistical-data/farmers-banefited/farmers-banefited.component';
import { WheatProcurementDataComponent } from './statistical-data/wheat-procurement-data/wheat-procurement-data.component';
import { RiceComponent } from './statistical-data/rice/rice.component';
import { PaddyComponent } from './statistical-data/paddy/paddy.component';
import { CoarseComponent } from './statistical-data/coarse/coarse.component';
import { StockComponent } from './statistical-data/stock/stock.component';
import { QualityControlComponent } from './statistical-data/quality-control/quality-control.component';
import { MovementComponent } from './statistical-data/movement/movement.component';
import { IrLComponent } from './statistical-data/ir-l/ir-l.component';
import { DepartmentalLaborComponent } from './statistical-data/departmental-labor/departmental-labor.component';
import { LabourStrengthComponent } from './statistical-data/labour-strength/labour-strength.component';
import { ImportExportComponent } from './statistical-data/import-export/import-export.component';
import { ImportWheatComponent } from './statistical-data/import-wheat/import-wheat.component';
import { MangmntDashComponent } from './management-dashboard/mangmnt-dash/mangmnt-dash.component';
import { ManagementLoginComponent } from './management-dashboard/management-login/management-login.component';
import { ArchiveOfficeOrderComponent } from './pages/archive-office-order/archive-office-order.component';

import { SeeyourdepotnewComponent } from './pages/seeyourdepotnew/seeyourdepotnew.component';
import { ContentDetailsComponent } from './pages/content-details/content-details.component';
import { WarehouseAssessmentComponent } from './pages/warehouse-assessment/warehouse-assessment.component';

const routes: Routes = [
  { path: "", component: HeadquarterComponent },
  { path: 'tender', component: TendersComponent },
  { path: 'tender-details/:tenderid', component: TendersDetailsComponent },
  { path: 'depot-details', component: DepotDetailsComponent },
  { path: 'gallery', component: GalleryComponent },
  { path: 'videogallery', component: VideoGalleryComponent },
  { path: 'view/:aliasName', component: WebsiteInnerLayoutComponent },
  { path: "insight-overview", component: OverviewComponent },
  { path: "procurement", component: ProcurementComponent },
  { path: 'pressrelease', component: PressReleasesComponent },
  { path: 'recruitment', component: RecruitmentComponent },
  { path: 'recruitment-details/:id', component: RecruitmentDetailsComponent },
  { path: 'circular', component: CircularComponent },
  { path: 'award', component: AwardsComponent },
  { path: 'sitemap', component: SitemapComponent },
  { path: 'seeyourdepot', component: SeeyourdepotComponent },
  { path: 'contactus', component: ContactusComponent },
  { path: 'annualreport', component: AnnualReportComponent },
  { path: 'pressreleasedetails/:id', component: PressReleaseDetailsComponent },
  { path: 'newslist', component: NewsListComponent},
  { path: 'circulardetails/:id', component: CircularDetailsComponent },
  // { path: 'directory', component: DirectoryComponent },//removed as per client
  { path: 'news/:id', component: NewsComponent },  
  { path: 'boardofdirectors', component: BoardDirectorsComponent },
  { path: 'awarddetails/:id', component: AwardDetailsComponent },
  { path: 'handbook', component: HandbookComponent },
  { path: 'whatsnewdetails', component: WhatsNewDetailsComponent },
  { path: 'feedbackform', component: FeedbackFormComponent },
  { path: 'gallerycategory', component: GalleryCategoryComponent },
  { path: 'notice-of-board-meetings', component: NoticeOfBoardMeetingComponent },
  { path: 'independent-non-official-directors', component: IndependentNonOfficialDirectorsComponent },
  { path: 'mous', component: MousListComponent },
  { path: 'contentsearch', component: ContentSearchComponent },
  { path: 'samplecontentpage', component: SampleContentPageComponent },
  { path: 'vigilance-contact-directory', component: VigilanceContactDirectoryComponent },
  { path: 'purchase-contact-directory', component: PurchaseContactDirectoryComponent },
  { path: 'contact-directory', component: ContactDirectoryComponent },
  { path: 'posting-transfer-promotions-order', component: OfficeOrderComponent },
  { path: 'archive-posting-transfer-promotions-order', component: ArchiveOfficeOrderComponent },
  { path: 'employeecorner', component: EmployeeCornerComponent },
  { path: 'employeecorner-details/:param_id', component: EmployeeCornerDetailsComponent },
  { path: 'organisation-structure', component: OrganisationStructureComponent },
  { path: 'gallery/:id', component: GalleryComponent },
  { path: 'videocategory', component: VideoCategoryComponent },
  { path: 'videogallery/:id', component: VideoGalleryComponent },
  { path: 'hospitallistfcihqrs', component: HospitalListFciHqrsComponent },
  { path: 'miskpizones', component: MisKpiZonesComponent },
  { path: 'miskpiregions', component: MisKpiRegionsComponent },
  { path: 'blogs', component: BlogsComponent },
  { path: 'blogdetails/:blog_id', component: BlogdetailsComponent },
  { path: 'Feedback', component: FeedbackComponent },
  { path: 'screenreader', component: ScreenReaderComponent },
  { path: 'immovableproperty', component: ImmovablePropertyComponent },
   {path : 'archivenewslist',component:NewslistArchiveComponent},
   {path  : 'archivepressrelease',component:PressreleaseArchiveComponent},
   {path :'archivecircular',component:CircularArchiveComponent},
   {path : 'archiveaward', component:AwardArchiveComponent},
   {path : 'archivtender', component:TenderArchiveComponent},
   {path : 'archivegallery', component:GalleryArchiveComponent},
   { path: 'archivegallery/:id', component: GalleryArchiveComponent },
   { path: 'archivevideogallery', component: VideoGalleryArchiveComponent },
   { path: 'archivevideogallery/:id', component: VideoGalleryArchiveComponent },
   { path: 'galleryCategoryarchive', component: GalleryCategoryArchiveComponent },
   {path :  'videoCategoryarchive',component:  VideoCategoryArchiveComponent},
   {path :  'statistical-data/wheat',component:  WheatProcurementDataComponent},
   { path: 'statistical-data/farmers', component: FarmersBanefitedComponent },
   { path: 'statistical-data/rice', component: RiceComponent },
   { path: 'statistical-data/paddy', component: PaddyComponent },
   { path: 'statistical-data/coarse', component: CoarseComponent },
   { path: 'statistical-data/stock', component: StockComponent },
   { path: 'statistical-data/quality-control', component: QualityControlComponent },
   { path: 'statistical-data/movement', component: MovementComponent },
   { path: 'statistical-data/ir-l', component: IrLComponent },
   { path: 'statistical-data/departmental-labor', component: DepartmentalLaborComponent },
   { path: 'statistical-data/labour-strength', component: LabourStrengthComponent },
  //  { path: 'statistical-data/export-data', component: ImportExportComponent },
   { path: 'statistical-data/import-wheat', component: ImportWheatComponent },
   {path :  'management-login',component:  ManagementLoginComponent},
   {path :  'management-login/management-dashboard',component:  MangmntDashComponent},
   {path :  'warehouse-assessment',component:  WarehouseAssessmentComponent},
  //  {
  //   path: 'statistical-data', 
  //   loadChildren: () => import('./statistical-data/statistical-data.module').then(m => m.StatisticalDataModule)
  // },
  { path: 'see-your-depot', component: SeeyourdepotnewComponent },
  {path :  'details/:pageid',component:  ContentDetailsComponent},
   { path: '**', component: ErrorPageComponent },//redirectTo: '/404'
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HeadquarterRoutingModule { }
